import React from "react";
import type { ISvgProps } from "components/icons/shared_props";

import { MAIN_THEME } from "styles/theme";

export default function LspdMinusCircle({
  size = MAIN_THEME.iconSize.small,
  color = MAIN_THEME.colors.lspdBlue500,
}: ISvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width={size}
      height={size}>
      <path
        d="M4 7c-.516 0-1 .264-1 1 0 .742.531 1 1 1h8c.437 0 1-.264 1-1 0-.742-.531-1-1-1H4z"
        fill={color}
      />
    </svg>
  );
}
